import React, {Component} from 'react';
import SimpleReactValidator from 'simple-react-validator';
import Errors from '../common/Errors'
import * as ApiConfig from '../../api-config.js';
import * as Util from '../common/Util';
import GoogleSignUp from "../security/GoogleSignUp";

class CreateOrg extends Component {
    constructor(props) {
        super(props);
        this.state = {
            countries:[],
            organization:{
                dateFormat:"MM/dd/yyyy",
                userRoles:"ROLE_ADMIN",
                country:"USA",
                name:"",
                domainPrefix:"",
                emailPrimary:"",
                firstName:"",
                lastName:"",
                password:"",
                confirm:"",
                userEnteredCaptcha:"",
                apiGeneratedCaptcha:""
            },
            bannedEmail: "",
            captchaEncode: "",
            showLoader:false,
            redirectToErrorPage:false,
            redirectToDashBoard:false,
            disabledButton:false,
            businessEmailValidationMessage:"",
            apiStatus:{
                isError:false,
                message:''
            },
            rediretPage: ''
        }

        this.fetchGeneralData = this.fetchGeneralData.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.populateDomainPrefix = this.populateDomainPrefix.bind(this);
        this.fetchCaptcha = this.fetchCaptcha.bind(this)
        this.validator = new SimpleReactValidator({autoForceUpdate: this,element: false});
    }
    handleChange(event) {
        const {organization} = this.state
        const target = event.target;
        const value = target.value;
        const name = target.name;
        organization[name] = value
		if(name === "name"){
			let domain = this.populateDomainPrefix(value)
			organization["domainPrefix"] = domain
		}
        this.setState({organization: organization});
    }

    componentDidMount(){
        this.fetchUtilityValue()
    }

    fetchGeneralData() {
        fetch(this.props.api + '/utility/dateformatAndCountryList', {
            method: "GET",
            mode: 'cors',
            headers: {
                "X-AUTH-TOKEN": this.props.jwtToken,
                'content-type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(json => {
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    this.props.onLogoutClick(json.message);
                } else {
                    this.setState({countries: json.countries});
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    fetchUtilityValue() {
        let requestObj = {}
        requestObj["fetchBannedEmail"] = true
        requestObj["fetchCaptcha"] = true
        fetch(this.props.backEndServerUrlWithoutDomain + '/api/dashboard/fetchUtilityValue?fetchBannedEmail='+true+"&fetchCaptcha="+true, {
            method: 'GET',
            mode: 'cors',
            headers: {
                "X-AUTH-TOKEN": this.props.jwtToken,
                'content-type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(json => {
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    this.props.onLogoutClick(json.message);
                } else {
                    const {organization} = this.state;
                    organization.apiGeneratedCaptcha = json.utilityData.captcha
                    this.setState({captchaEncode: json.utilityData.captchaEncode, organization:organization, bannedEmail: json.utilityData.bannedEmail});
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    fetchCaptcha(){
        fetch(ApiConfig.BACKEND_SERVER_WIHTOUT_DOMAIN + '/api/generateCaptcha', {
            method: "GET",
            mode: 'cors',
            headers: {
                "X-AUTH-TOKEN": this.props.jwtToken,
                'content-type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(json => {
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    this.props.onLogoutClick(json.message);
                } else {
                    const {organization} = this.state;
                    organization.apiGeneratedCaptcha = json.captcha
                    this.setState({captchaEncode: json.captchaEncode, organization:organization});
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    handleSubmit(event) {
        event.preventDefault();
        console.log(ApiConfig.BACKEND_SERVER_WIHTOUT_DOMAIN + '/api/organization');
        if (this.validator.allValid()) {
            let {organization} = this.state;
           if(Util.validateBusinessEmail(organization.emailPrimary, this.state.bannedEmail)) {
                this.setState({showLoader: true, businessEmailValidationMessage: ''});
                let postingRequest = {};
                postingRequest["name"] = organization.name;
                postingRequest["domainPrefix"] = organization.domainPrefix;
                postingRequest["dateFormat"] = organization.dateFormat;
                postingRequest["autoLogin"] = true;
                postingRequest["userEnteredCaptcha"] = organization.userEnteredCaptcha
                postingRequest["apiGeneratedCaptcha"] = organization.apiGeneratedCaptcha

                postingRequest["address"] = {};
                postingRequest["address"]["street1"] = organization.street1
                postingRequest["address"]["street2"] = organization.street2
                postingRequest["address"]["city"] = organization.city
                postingRequest["address"]["state"] = organization.state
                postingRequest["address"]["countryCode"] = organization.country
                postingRequest["address"]["zip"] = organization.zip

                postingRequest["staff"] = {};
                postingRequest["staff"]["emailPrimary"] = organization.emailPrimary
                postingRequest["staff"]["password"] = organization.password
                postingRequest["staff"]["confirm"] = organization.confirm
                postingRequest["staff"]["firstName"] = organization.firstName
                postingRequest["staff"]["lastName"] = organization.lastName
                postingRequest["staff"]["workPhone"] = organization.workPhone
                fetch(ApiConfig.BACKEND_SERVER_WIHTOUT_DOMAIN + '/api/organization', {
                    method: 'POST',
                    mode: 'cors',
                    body: JSON.stringify(postingRequest),
                    headers: {
                        'content-type': 'application/json'
                    }
                })
                    .then(response => response.json())
                    .then(json => {
                        this.setState({showLoader: false});
                        const {apiStatus} = this.state;
                        if (json && json.isError === false) {
                            apiStatus.isError = false;
                            apiStatus.message = json.message;
                            this.setState({disabledButton: false, apiStatus: apiStatus});
                            let urlPrefix = ApiConfig.FRONT_END_HOST.replace("://", "://" + organization.domainPrefix + ".") + "/#/login/auto/" + encodeURIComponent(json.autoLoginToken);
                            window.location.href = urlPrefix
                        } else {
                            apiStatus.isError = true;
                            apiStatus.message = json.message;
                            apiStatus.messages = json.messages;
                            this.setState({disabledButton: false, apiStatus: apiStatus, redirectToDashBoard: false})
                            this.fetchCaptcha()
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        this.setState({showLoader: false});
                        const {apiStatus} = this.state;
                        apiStatus.isError = true;
                        apiStatus.message = error;
                        this.setState({disabledButton: false, apiStatus: apiStatus});
                        this.fetchCaptcha()
                    });
            }else{
                this.setState({businessEmailValidationMessage: this.props.msg('createOrg.businessEmailInfo')})
            }
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    /*Auto Populate Domain prefix from org name*/
    populateDomainPrefix(value){
        var b = '';
        for (var i = 0; i < value.length; i++) {
            if ((value[i] >= 'A' && value[i] <= 'Z') || (value[i] <= 'z' && value[i] >= 'a'))
                b += value[i].toLowerCase();
        }
        return b;
    }

    render() {
        let _this = this;
        return (
            <React.Fragment>
                <div className="container-fluid no-gutters">
                    <div className="col-lg-6 col-md-6 left-box hidden-xs hidden-sm">
                        <h1>Get eSignature & Payments <br/>In One Step!</h1>
                        <img src="img/Hero-banner@2x.png" alt=""/>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 right-box">
                        <img src="img/blu-icon@2x.png" alt=""/>
                        <GoogleSignUp/> <p className="text-center"> Or </p>
                        <h3 className="text-center">
                            {_this.props.msg('createOrg.title')}
                        </h3>
                        <Errors errorObject={this.state.apiStatus}/>
                        {this.state.showLoader === true ? (<div className="loading">Loading&#8230;</div>) : ''}
                        <form  method="post" id="createOrg" onSubmit={this.handleSubmit}>
                            <div className="col-lg-12 clearfix m-b no-gutters">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 padd-right">
                                    <input type="text" placeholder="First Name" className="form-control required-field" id="firstName"
                                           name="firstName" autoComplete="off"
                                           value={this.state.organization.firstName?this.state.organization.firstName:''} onChange={this.handleChange}/>
                                    <div style={{color:"#dc3545"}}>
                                        {this.validator.message('first name', this.state.organization.firstName, 'required|min:3|max:30')}
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 padd-left">
                                    <input type="text" placeholder="Last Name" className="form-control required-field" id="lastName"
                                           name="lastName" autoComplete="off"
                                           value={this.state.organization.lastName?this.state.organization.lastName:''} onChange={this.handleChange}/>
                                    <div style={{color:"#dc3545"}}>
                                        {this.validator.message('last name', this.state.organization.lastName, 'required|min:3|max:30')}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 m-b">
                                <input type="text" id="name" autoComplete="off"
                                       name="name" placeholder="Company Name" onChange={this.handleChange}
                                       className="form-control required-field" value={this.state.organization.name?this.state.organization.name:''}/>
                                <div style={{color:"#dc3545"}}>
                                    {this.validator.message('Company name', this.state.organization.name, 'required|min:3|max:50')}
                                </div>
                            </div>
                            <div className="col-lg-12 m-b-xs">
                                <span className="text-primary"> Your personalized login</span>
                            </div>
                            <div className="col-lg-12 m-b https-box">
                                <span className="text-primary">https://</span>
                                <input type="text" placeholder="" className="form-control required-field" id="domainPrefix" autoComplete="off"
                                       name="domainPrefix" value={this.state.organization.domainPrefix?this.state.organization.domainPrefix:''} onChange={this.handleChange}/>
                                <span className="text-primary">.{ApiConfig.SERVER_HOST}</span>
                                <div style={{color:"#dc3545"}}>
                                    {this.validator.message('Domain', this.state.organization.domainPrefix, 'required|min:3|max:50')}
                                </div>
                            </div>
                            <div className="col-lg-12 m-b">
                                <input type="text" placeholder="Email ID" className="form-control required-field" name="emailPrimary" id="emailPrimary" autoComplete="off"
                                       value={this.state.organization.emailPrimary?this.state.organization.emailPrimary:''} onChange={this.handleChange}/>
                                <div style={{color:"#dc3545"}}>
                                    {this.validator.message('email', this.state.organization.emailPrimary, 'required|email')}
                                </div>
                                <div style={{color:"#dc3545"}}>
                                    {this.state.businessEmailValidationMessage?this.state.businessEmailValidationMessage:''}
                                </div>
                            </div>
                            <div className="col-lg-12 clearfix m-b no-gutters">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 padd-right">
                                    <input type="password" placeholder="Password" className="form-control" name="password" id="password" autoComplete="new-password"
                                           value={this.state.organization.password?this.state.organization.password:''} onChange={this.handleChange}/>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 padd-left">
                                    <input type="password" placeholder="Confirm Password" className="form-control" id="confirm"
                                           name="confirm" autoComplete="new-confirm"
                                           value={this.state.organization.confirm?this.state.organization.confirm:''} onChange={this.handleChange}/>
                                </div>
                            </div>
                            <div>
                                <div style={{
                                    border: '1px solid',
                                    display: 'block',
                                    width: '300px',
                                    height: '150px',
                                    clear: 'left',
                                    marginLeft: '15px'
                                }}>
                                    <div className="col-lg-12 clearfix m-b no-gutters">
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 padd-right">
                                            <img src={`data:image/png;base64,${this.state.captchaEncode}`}
                                                 style={{margin: '10px'}}></img>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                            <a><i className="fa fa-refresh m-t fa-lg" style={{float: 'right'}}
                                                  title="Refresh" onClick={this.fetchCaptcha}></i></a>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 m-b m-l-xl">
                                        <input type="text" placeholder="Enter captcha" style={{width: '125px'}}
                                               className="form-control required-field" id="userEnteredCaptcha"
                                               name="userEnteredCaptcha" autoComplete="off"
                                               value={this.state.organization.userEnteredCaptcha ? this.state.organization.userEnteredCaptcha : ''}
                                               onChange={this.handleChange}/>
                                        <div style={{color: "#dc3545"}}>
                                            {this.validator.message('Captcha', this.state.organization.userEnteredCaptcha, 'required')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*<div className="col-lg-12 m-b">
                                    <div className="form-group m-t-sm">
                                        <div className="i-checks">
                                            <label><input type="checkbox"/>I accept the terms and conditions
                                            </label>
                                        </div>
                                    </div>
                                </div>*/}
                            <div className="col-lg-12 m-b-md m-t">
                                <button className="btn btn-primary button-style" type="submit">
                                    {_this.props.msg('createOrg.createAccountButton')}
                                </button>
                            </div>
                        </form>

                        {/*<div className="col-lg-12 m-b-md">
                                    <div className="or-devider text-center">
                                        or
                                    </div>
                                </div>
                                <div className="col-lg-12 m-b-md">
                                    <button className="btn btn-primary button-style" type="button"><i className="fa fa-google"/>Continue with Google</button>
                                </div>*/}

                    </div>
                    <style dangerouslySetInnerHTML={{
                        __html: `
                        `
                    }}/>
                </div>
            </React.Fragment>

        );
    }
}
export default CreateOrg;


// WEBPACK FOOTER //
// ./src/components/organization/CreateOrg.js